import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.75 18H17.25V5.25H6.75V18ZM18.75 1.5H5.25C4.0125 1.5 3 2.5125 3 3.75V20.25C3 21.4928 4.008 22.5 5.25 22.5H18.75C19.992 22.5 21 21.4928 21 20.25V3.75C21 2.5125 19.9875 1.5 18.75 1.5Z" // eslint-disable-line
 }), 'TabletFilled');
